import type { Environment } from "@granular/fabric3-definitions";
import { useCountryFromUrl } from "../hooks/useCountryFromUrl";

export const SHORT_TO_FULL_ENVIRONMENT_NAME_MAP: Record<string, Environment> = {
  d: "development",
  dev: "development",
  p: "production",
  prod: "production",
  t: "test",
  test: "test",
} as const;

declare global {
  var RUNTIME_ENVIRONMENT: Environment | undefined;
}

export const getEnvironment = (usePreferredIfLocal = true): Environment => {
  if (
    // `nginx` is for when we use Docker
    globalThis.location.hostname.includes("nginx") ||
    globalThis.location.hostname.includes("localhost") ||
    globalThis.location.hostname.includes("127.0.0.1")
  ) {
    return (
      (usePreferredIfLocal ? globalThis.RUNTIME_ENVIRONMENT : undefined) ??
      "local"
    );
  }
  if (
    globalThis.location.hostname.includes(".dev.") ||
    globalThis.location.hostname.startsWith("dev.")
  ) {
    return "development";
  }
  if (
    globalThis.location.hostname.includes(".test.") ||
    globalThis.location.hostname.startsWith("test.")
  ) {
    return "test";
  }

  return "production";
};

/**
 * We don't use short names anywhere except for here.
 */
const SHORT_ENV_MAP: Record<Environment, string> = {
  local: "dev.",
  development: "dev.",
  test: "test.",
  production: "",
};

export const getShortEnv = (): string => {
  return SHORT_ENV_MAP[getEnvironment(true)];
};

export const useInsightsUrl = () => {
  return new URL(
    "/",
    `https://${useCountryFromUrl()}.${getShortEnv()}insights.granular.ag`,
  );
};
